import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  AuthConfig,
  NullValidationHandler,
  OAuthService,
} from 'angular-oauth2-oidc';
import * as jose from 'jose';
//import { AwaitingService } from './awaiting.service';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  constructor(
    private oauthService: OAuthService,
    private route: ActivatedRoute,
    //private awaitingSvc: AwaitingService
  ) {}

  login(authConfig: AuthConfig) {
    // create a /auth request for code authorization flow
    this.route.queryParams.subscribe(async (params) => {

      try {
        let tempCred = params['tempCred'];
        let tenant = params['tenanthost'];

        /*Self services forms params value*/
        let formName = params['formName'];

        let isFtlApp = false;

        if (authConfig.clientId === 'bawag-ftl-online' || authConfig.clientId === 'easy-ftl-online'){
          isFtlApp = true;
        }

        let disp : any;
        if(tenant && tenant === 'eb'){
          // for ebanking tempcred
          const joses = jose.decodeJwt(tempCred);
          disp = joses['disposer_number'];
        } else{
          const tempCredParsed = tempCred ? JSON.parse(atob(tempCred)) : '';
          disp = tempCredParsed.data.disposer;
        }

        this.oauthService.configure(authConfig);
        this.oauthService.tokenValidationHandler = new NullValidationHandler();
        this.oauthService.loadDiscoveryDocument().then(() => {
          //this.awaitingSvc.setIsLoading(false);
          if (formName){
            this.oauthService.initLoginFlow('', {
              username: disp,
              tempCred: tempCred,
              formName: formName
            });
          }
          else {
            if (isFtlApp) {
              this.oauthService.initLoginFlow('', {
                username: disp,
                tempCred: tempCred,
                klarFlow: 'true'
              });
            } else {
              this.oauthService.initLoginFlow('', {
                username: disp,
                tempCred: tempCred,
              });
            }
          }
        });

        // this.oauthService.tryLogin({
        //   onTokenReceived: () => {
        //     this.awaitingSvc.setIsLoading(false);
        //   }
        // });
      } catch (e) {
        // In case something does not work redirect to product
        window.location.href = <string>authConfig.redirectUri;
      }
    });
  }
}